import { ApiFunc, getInstance } from '@helpers/httpClient'
import { prop } from 'ramda'

import * as API from '../constants/api'

const instance = getInstance()

export const feedbackAll: ApiFunc<`${typeof API.FEEDBACK_ALL}`, 'get'> = data =>
  instance.get(API.FEEDBACK_ALL, { params: data })

export const feedbackList: ApiFunc<`${typeof API.FEEDBACK}`, 'get'> = data =>
  instance.get(API.FEEDBACK, { params: data })

export const feedbackCreate: ApiFunc<`${typeof API.FEEDBACK}`, 'post'> = data => instance.post(API.FEEDBACK, data)

export const feedbackTypes: ApiFunc<`${typeof API.FEEDBACK_TYPES}`, 'get'> = data =>
  instance.get(API.FEEDBACK_TYPES, { params: data })

export const feedbackEdit: ApiFunc<`${typeof API.FEEDBACK_EDIT}`, 'get'> = data =>
  instance.get(API.FEEDBACK_EDIT, { params: data })

export const feedbackUpdate: ApiFunc<`${typeof API.FEEDBACK_UPDATE}`, 'put'> = data =>
  instance.put(API.FEEDBACK_UPDATE, data)

export const feedbackForm: ApiFunc<`${typeof API.FEEDBACK_FORM}{id}`, 'get'> = data =>
  instance.get(`${API.FEEDBACK_FORM}${'id' in data ? prop('id', data) : data?.name}`, { params: data })

export const feedbackFormAll: ApiFunc<`${typeof API.FEEDBACK_FORM_ALL}`, 'get'> = data =>
  instance.get(API.FEEDBACK_FORM_ALL, { params: data })

export const FeedbackFormList: ApiFunc<`${typeof API.FEEDBACK_FORM}`, 'get'> = data =>
  instance.get(API.FEEDBACK_FORM, { params: data })

export const feedbackFormCreate: ApiFunc<`${typeof API.FEEDBACK_FORM}`, 'post'> = data =>
  instance.post(API.FEEDBACK_FORM, data)

export const feedbackFormDelete: ApiFunc<`${typeof API.FEEDBACK_FORM}{id}`, 'delete'> = data =>
  instance.delete(`${API.FEEDBACK_FORM}${'id' in data ? prop('id', data) : data?.name}`)
